import { CanonicalLoad } from '@numeo/types-core'
import { cityLabel } from './format'

/** Prefilled operator → driver SMS. Short by design (SMS bills per 160-char segment) and fully editable
 *  in the compose modal. Ends with the "open in app, else store" load link (a raw URL — SMS has no anchor
 *  text, so the phone auto-linkifies the URL, not the words "Bid here"). */
export const buildDriverSmsMessage = (load: CanonicalLoad, loadUrl: string): string => {
    const origin = cityLabel(load.pickupCity, load.pickupStateProv)
    const destination = cityLabel(load.deliveryCity, load.deliveryStateProv)
    return `Numeo load: ${origin} -> ${destination}. Interested? Bid here: ${loadUrl}`
}

/** Default recruiting SMS an operator sends to a My Drivers driver — the company pitch + MC/DOT. Long-form
 *  (multi-segment) and fully editable in the compose modal; seeded as the initial text there. */
export const BOX_TRUCK_RECRUIT_SMS = `Our company located in NORTHWOOD, OH 43619. We have been in this business for more than 2 years. What we offer for our new Owner Operators and Drivers?

1) 24/7 Dispatch, Update and HR services
2) Loads in all across the USA (Local, Regional, OTR Loads) in all across the USA
3) Friendly and kind dispatchers
4) 2 option of payments — 1) Quick Pay option takes from 1-3 business days with 5% charge. 2) Regular Payment takes from 6-7 business without any charges
5) We offering free bidding app which is named ATRECK in which you can see loads and bid on them

By the way here is our MC and DOT number:
USDOT: 4271912
MC : 1659184`
